/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ISmsOptInStatus, ESmsOptInStatus, ISmsInvitation, EFormSubmitResult } from '../../../core/models';

@Component({
  selector: 'fm-driver-sms-message',
  templateUrl: './driver-sms-message.component.html',
  styleUrls: ['./driver-sms-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DriverSmsMessageComponent {
  @Input()
  public smsMessage: UntypedFormGroup;

  @Input()
  public smsOptInStatus: ISmsOptInStatus;

  @Input()
  public isFormSubmitted: boolean;

  @Input()
  public phoneNumber: string;

  @Input()
  public set smsInvitation(invitation: ISmsInvitation) {
    if (invitation) {
      this._onInvitationSent(invitation);
    }
  }

  @Output()
  sendSmsInvitation: EventEmitter<void> = new EventEmitter();

  public ESmsOptInStatus = ESmsOptInStatus;
  public isInvitationSending: boolean;
  public invitationResult: string;

  public get message() {
    return this.smsMessage.get('message');
  }

  public onSendInvitationClick(): void {
    this.isInvitationSending = true;
    this.sendSmsInvitation.emit();
  }

  private _onInvitationSent(invitation: ISmsInvitation): void {
    this.isInvitationSending = false;
    this.invitationResult = invitation.Invited ? EFormSubmitResult.Success : EFormSubmitResult.Error;
  }
}
